const LeaveAPI = {
  API_ROOT_URL: '/leave'
};

export default LeaveAPI;
